import { PathTracingSceneGenerator } from 'three-gpu-pathtracer'
import { SAH } from 'three-mesh-bvh'
import { GenerateMeshBVHWorker } from 'three-mesh-bvh/src/workers/GenerateMeshBVHWorker'

export class PathTracingSceneWorker extends PathTracingSceneGenerator {
  constructor() {
    super()
    this.bvhGenerator = new GenerateMeshBVHWorker()
  }

  generate(scene: any, options = {}) {
    const { bvhGenerator } = this
    const { geometry, materials, textures, lights } = this.prepScene(scene)

    const bvhOptions = { strategy: SAH, ...options, maxLeafTris: 1 }
    const bvhPromise = bvhGenerator.generate(geometry, bvhOptions)
    return bvhPromise.then((bvh: any) => {
      return {
        scene,
        materials,
        textures,
        bvh,
        lights,
      }
    })
  }

  dispose() {
    this.bvhGenerator.dispose()
  }
}
